<template>
  <div class="services-details-bg pt-120 pb-100">
    <div class="container">
      <!-- Images: Side-by-Side -->
      <div class="services-details-img d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/ser2.jpg"
          alt="services-details"
          class="top-banner-img"
        />
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/tv.jpg"
          alt="services-details"
          class="top-banner-img"
        />
      </div>

      <!-- Content and Sidebar -->
      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content pt-4">
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Ad Shoots & TV Commercials (TVC)</h2>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Lights. Camera. Brand Impact.</h3>
            <p>
              At <strong>MyCelebrity</strong> by Digitalentio, we bring your brand
              story to life through cinematic ad shoots, TV commercials, and multiplex
              screen ads that leave a lasting impression on your audience.
            </p>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>
            <ul>
              <li>
                <b>TVCs (Television Commercials):</b> We produce high-quality TVCs
                from script to screen — featuring celebrities, crisp storytelling, and
                professional-grade production.
              </li>
              <li>
                <b>Digital Ad Shoots:</b> Instagram reels, YouTube pre-rolls, or brand films —
                optimized for digital platforms with maximum scroll-stopping potential.
              </li>
              <li>
                <b>Multiplex Cinema Ads:</b> Get featured on the big screen! Tailored ads
                for PVR, INOX, Cinepolis, and others — perfect for high-footfall campaigns.
              </li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Do:</h3>
            <ul>
              <li><b>Concept Development & Scriptwriting:</b> Unique brand-aligned narratives.</li>
              <li><b>Casting & Talent Management:</b> From influencers to film stars.</li>
              <li><b>Production & Direction:</b> Shoots with top-tier professionals.</li>
              <li><b>Location & Set Design:</b> Custom setups per brand.</li>
              <li><b>Post-Production & Editing:</b> VFX, audio, editing for all platforms.</li>
              <li><b>Media Planning & Distribution:</b> Smart placement for max visibility.</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Brands We've Worked With:</h3>
            <ul>
              <li><b>GoDesi</b> – Festive TVC with celebrity appeal.</li>
              <li><b>Sunpure</b> – Emotional storytelling in high-quality TVCs.</li>
              <li><b>Instapure</b> – Clean lifestyle ads.</li>
              <li><b>Jos Alukkas & Be Bodywise</b> – Fashion/grooming influencer shoots.</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Why Choose Us?</h3>
            <ul>
              <li>Script to shoot to publish — all-in-one solution.</li>
              <li>Experience with celebrities & influencers.</li>
              <li>TV + Digital + Regional support.</li>
              <li>Creative meets commercial — every frame sells.</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease;
}

// Light mode (default)
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark mode
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-img {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .top-banner-img {
    width: 48%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-family: var(--bodyFontFamily);
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive */
@media only screen and (max-width: 767px) {
  .services-details-img {
    flex-direction: column;
    align-items: center;

    .top-banner-img {
      width: 100%;
      max-height: 220px;
    }
  }

  .services-details-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .col-lg-4 {
    margin-top: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-img .top-banner-img {
    max-height: 300px;
  }

  .services-details-content h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }
}
</style>
